/* SEIKIS — global base.js
   Minimal global behaviors: cart count live updates, skip-link smooth, prefers-reduced-motion respect. */
(function () {
  'use strict';

  // ── Live cart count (listens for cart updates from our PDP, also Shopify drawer events) ──
  document.addEventListener('cpp:added', refreshCartCount);
  document.addEventListener('cart:refresh', refreshCartCount);
  document.addEventListener('cart:added', refreshCartCount);

  async function refreshCartCount() {
    try {
      const resp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await resp.json();
      const badge = document.querySelector('[data-cart-count]');
      if (!badge) return;
      if (cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    } catch (e) { /* silent */ }
  }

  // ── Smooth scroll skip-link to focus main ──
  document.querySelectorAll('a.skip-link').forEach((el) => {
    el.addEventListener('click', (e) => {
      const target = document.querySelector(el.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.setAttribute('tabindex', '-1');
        target.focus();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
